export const createPointName = (
  firstSegment: string,
  secondSegment: string,
): string => `${firstSegment}<br/>${secondSegment}`.toUpperCase();
